<template>
  <div>
    <b-card>
      <title-text />
      <sub-title-text />
      <content-text />
      <button-text />
      <template v-if="dataItem.button">
        <mod-leads-url-text />
        <mod-leads-target-select />
      </template>
      <mod-leads-type-select />
      <status-select />
    </b-card>
    <template v-if="!['3','4'].includes(dataItem.lead_type)">
      <mod-leads-image-card />
    </template>

  </div>
</template>
<script>
import { BCard } from 'bootstrap-vue'
import TitleText from '@/views/Admin/Mod_leads/elements/TitleText.vue'
import SubTitleText from '@/views/Admin/Mod_leads/elements/SubTitleText.vue'
import ContentText from '@/views/Admin/Mod_leads/elements/ContentText.vue'
import ButtonText from '@/views/Admin/Mod_leads/elements/ButtonText.vue'
import StatusSelect from '@/views/Admin/Mod_leads/elements/StatusSelect.vue'
import ModLeadsImageCard from '@/views/Admin/Mod_leads/elements/ImageCard.vue'
import ModLeadsTypeSelect from '@/views/Admin/Mod_leads/elements/LeadTypeSelect.vue'
import ModLeadsUrlText from '@/views/Admin/Mod_leads/elements/UrlText.vue'
import ModLeadsTargetSelect from '@/views/Admin/Mod_leads/elements/LeadTargetSelect.vue'

export default {
  name: 'ModLeadsItemForm',
  components: {
    ModLeadsTargetSelect,
    ModLeadsUrlText,
    ModLeadsTypeSelect,
    ModLeadsImageCard,
    BCard,
    TitleText,
    SubTitleText,
    ContentText,
    ButtonText,
    StatusSelect,
  },
  computed: {
    dataItem() {
      return this.$store.getters['modLeads/dataItem']
    },
  },
}
</script>
